import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d6d3a240&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d6d3a240&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d3a240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6d3a240')) {
      api.createRecord('d6d3a240', component.options)
    } else {
      api.reload('d6d3a240', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d6d3a240&scoped=true", function () {
      api.rerender('d6d3a240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/product/index.vue"
export default component.exports